import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './index.module.scss';
import { t } from 'i18next';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  muiButtonTheme: {
    background: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    padding: '0.7rem 1rem',
    border: 'none',
    '&:hover': {
      opacity: 1,
      background: theme.palette.primary.main,
    },
    '&:disabled': {
      opacity: 0.9,
    },
  },
  outline: {
    border: `2px solid ${theme.palette.primary.main}`,
    background: theme.palette.background.default,
    color: theme.palette.text.primary,
    '&:hover': {
      opacity: 1,
      background: theme.palette.background.default,
    },
    '&:disabled': {
      opacity: 0.9,
    },
  },
}));

const CustomButton = ({
  disabled,
  onClick,
  text,
  className,
  size,
  id,
  type,
  icon,
  onError,
  navigatetohome,
  outline,
}) => {
  const classes = useStyles();
  return (
    <Button
      className={cn(
        classes.muiButtonTheme,
        styles[size],
        styles.default,
        className,
        { [classes.outline]: outline },
      )}
      size={'medium'}
      variant={'contained'}
      disabled={disabled}
      onClick={typeof navigatetohome === 'function' ? navigatetohome : onClick}
      id={id}
      type={type}
      startIcon={icon}
      onError={onError}
    >
      {t(text)}
    </Button>
  );
};
export default CustomButton;

CustomButton.propTypes = {
  type: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  text: PropTypes.string,
  outline: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['s', 'm', 'l', 'xl', 'auto']),
  color: PropTypes.oneOf(['primary', 'secondary', 'warning']),
  theme: PropTypes.oneOf(['dark', 'light']),
  icon: PropTypes.element,
  onError: PropTypes.func,
  navigatetohome: PropTypes.func,
};

CustomButton.defaultProps = {
  type: 'button',
};
